import { memoize, titleCase, uniqueByKey } from '@ls/js-utils';
import { createSelector } from 'reselect';
import SelectionState from 'state/selections/SelectionState';
import scope from './scope';

export const selectDefinitions = memoize((selectionState) => {
  if (selectionState === SelectionState.UNCOMMITTED) {
    return (state) => state[scope]['definitions'][selectionState];
  }

  return createSelector(
    (state) => state[scope]['definitions'][selectionState],
    (definitions) => {
      const completeDefinitions = definitions.filter(
        ({ complete }) => complete
      );
      return completeDefinitions.filter(
        uniqueByKey(completeDefinitions, 'key')
      );
    }
  );

});

export const selectHoldingColumnDefs = createSelector(
  selectDefinitions(SelectionState.COMMITTED),
  (definitions) => {
    return definitions.map(({ attribute, key }) => {
      return {
        headerName: `${titleCase(attribute)}`,
        field: key,
        colId: key,
      };
    }, []
    );
  }
);
